import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'

// 只需要引入这个文件即可，内部已完成指令注册
import '@/utils/permission'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 全局确认对话框方法
Vue.prototype.$modalSure = function(message) {
  return new Promise((resolve, reject) => {
    this.$confirm(message, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      resolve()
    }).catch(() => {
      reject()
    })
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
